import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '@repo/lib-design-system/utils/tw-merge.util';

function Footer(): ReactElement {
  const { t } = useTranslation();

  return (
    <footer className="flex flex-col items-center justify-center gap-2 px-8 py-6 text-center">
      <a
        href="https://hikoala.co/"
        rel="noreferrer"
        target="_blank"
        className={cn(
          'text-sm font-semibold text-brand-purple underline underline-offset-2',
          'hover:opacity-80'
        )}
      >
        hikoala.co
      </a>
      <div className="text-xs text-grey-600 dark:text-grey-300">
        <address className="not-italic">{t('footer.address')}</address>
        <p>{t('footer.orias')}</p>
      </div>
    </footer>
  );
}

export default Footer;
